// import * as Dashboards from "./Dashboards";

import Dashboard from "./Dashboard";
import Settings from "./Settings";
import DeliveryTimeReport from "./Orders";
import Menus from "./Menus";
import MenuItems from "./MenuItems";
import Sites from "./Locations/Sites";
import Kitchens from "./Locations/Kitchens";
import SubSpaces from "./Locations/SubSpaces";
import Spaces from "./Locations/Spaces";
import ManageTeam from "./Locations/Manage-team";
import Clickers from "./Devices";
import Splash from "./Settings/Splash";
import AppVersion from "./Settings/AppVersion";
import StationExperience from "./StationExperience";

export {
  Spaces,
  SubSpaces,
  Menus,
  MenuItems,
  Sites,
  Kitchens,
  DeliveryTimeReport,
  Settings,
  Dashboard,
  Clickers,
  ManageTeam,
  Splash,
  AppVersion,
  StationExperience
};
